export class SuppressionReason {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
}

export default SuppressionReason;